export const ROUTES = {
  root: '/',
  login: '/login',
  forgotPassword: '/login/forgot',
  register: '/register',
  verify: '/register/verify',
  profile: '/profile',
  products: '/products',
  productNew: '/products/new',
  productEdit: (id: string) => `/products/${id}/edit`,
  buyRequests: '/buy-requests',
  buyRequestDetail: (id: string) => `/buy-requests/${id}`,
  quotes: '/quotes',
  crm: '/crm',
  orders: '/orders',
  orderDetail: (id: string) => `/orders/${id}`,
  shipments: '/shipments',
  chats: '/chats',
  chatDetail: (id: string) => `/chats/${id}`,
  notifications: '/notifications',
  settings: '/settings',
  settingsAccount: '/settings/account',
  settingsSecurity: '/settings/security',
} as const;
